"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var ReleaseActionRequest_1 = require("../model/ReleaseActionRequest");

var ReleaseActionRequestConverter_1 = require("./ReleaseActionRequestConverter");
/**
 * @author Radek Beran
 */


var ReleaseActionRequestConverterImpl =
/*#__PURE__*/
function (_ReleaseActionRequest) {
  _inherits(ReleaseActionRequestConverterImpl, _ReleaseActionRequest);

  function ReleaseActionRequestConverterImpl() {
    _classCallCheck(this, ReleaseActionRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionRequestConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseActionRequestConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleaseActionRequest_1.ReleaseActionRequest(ReleaseActionRequest_1.ReleaseActionRequest.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ReleaseActionRequest_1.ReleaseActionRequest.schema.action.valueOfField(source), ReleaseActionRequest_1.ReleaseActionRequest.schema.allCategories.valueOfField(source), ReleaseActionRequest_1.ReleaseActionRequest.schema.categoryIds.valueOf(conversions.asObjectList(source, 'categoryIds', function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("category id cannot be empty!");
        }

        return conversions.toClassReferenceId(value);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      throw new Error('Not implemented because it is not needed.');
    }
  }]);

  return ReleaseActionRequestConverterImpl;
}(ReleaseActionRequestConverter_1.ReleaseActionRequestConverter);

exports.ReleaseActionRequestConverterImpl = ReleaseActionRequestConverterImpl;